<!-- 短剧小程序列表。已废弃？ -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">小程序列表</div>
	
	<!-- <div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 15px;position: sticky;left: 30px;z-index: 5;width: 860px;">
		
		<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
	</div> -->
	
	<!-- 表头 -->
	<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
		<div  v-for="(item,index) in rableTitle" :key="index" >
			<div class="table-th-cell" 
			:style="{'width':item.width + 'px',}">
				{{item.title}}
			</div>
		</div>
	</div>
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<!-- <div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex <= sticky_index" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
			</template>
		</div>
		<template v-for="(z_tem,z_ndex) in rableTitle">
			<div v-if="z_ndex > sticky_index " class="table-td-cell"
			 :class="{'text-right': rableTitle[z_ndex].text_right}"
			:style="{'width':rableTitle[z_ndex].width + 'px'}">
				{{item[z_tem.type]}}
			</div>
			
		</template> -->
		
		
	</div>
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	
	<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_null_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" />
		
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
// import { channelLists } from '@/request/api'
export default {
	name: 'videoXcxList_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"小程序ID", width:120, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"小程序名称", width:200, type:"channel_name", },
				{title:"所属渠道", width:200, type:"channel_id", },
				{title:"平台（微信，抖音）", width:200, type:"return_point", },
				{title:"平台APPID", width:200, type:"type", },
				// {title:"操作", width:120, type:"cz", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false,
			sticky_index: 1,
			
			r_page: 1,
			table_total: 0,
			r_limit: 50,
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		that.searchButton()
	},
	methods:{
		// 搜索
		searchButton(){
			let that = this
			// that.search_button_loading = true
			// type:0这里是固定拿投放的数据
			// channelLists({
			// 	page: that.r_page, 
			// 	limit: that.r_limit,
			// 	type:"0",
			// }).then(res=>{
			// 	console.log("渠道列表",res.data);
			// 	that.search_button_loading = false
			// 	if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
			// 		that.$message.success('搜索成功');
			// 		that.table_total = res.data.data.total
			// 		that.tableShowData = res.data.data.data
			// 	}
			// 	else {
			// 		if(res.data.code === 401){ // 未登录
			// 			localStorage.removeItem("access_token");
			// 			that.$router.replace({name: 'login',params: {type:'not_log'}})
			// 		}
			// 		else {
			// 			that.$message.error(`其他错误：${res.data.msg}`);
			// 		}
			// 	}
			// })
		},
		paginationChange(){
			
		},
	}
}
</script>

<style>
</style>